<h1 i18n="@@upp.pointOfSale.create.title">Create Point of Sale</h1>

<div class="container-fluid">
  <ama-loading-alert [sendingStatus]="sendingStatus" message="Loading..." i18n-message="@@upp.global.messages.loading">
  </ama-loading-alert>
</div>

<ama-upp-notification
  [mainMessages]="mainMessages"
  [notification]="(notification$ | async)!"
  (closeNotificationEvent)="closeNotification()"
  (openDisplayEvent)="showPosInDisplay()"
>
</ama-upp-notification>

<ama-ng-upp-pos-details
  [posDetailsForm]="posForm"
  [posDetails]="posDetails"
  [readonly]="readonly"
  [parent]="uppComponent"
>
</ama-ng-upp-pos-details>

<div class="d-flex justify-content-end">
  @if (!sendingStatus) {
  <button
    i18n="@@upp.global.button.save"
    type="submit"
    class="btn btn-primary mb-2 mb-md-0 me-2"
    [disabled]="!saveButtonEnabled()"
    (click)="saveData()"
  >
    Save
  </button>
  } @if (sendingStatus) {
  <button i18n="@@upp.global.button.save" type="button" disabled class="btn btn-primary mb-2 mb-md-0 me-2">
    Save
  </button>
  }
</div>
